// Brand-wide settings. Update these in one place when handles, contact
// details or label wording change.

export const site = {
  name: 'Royal T',
  tagline: 'Nutrition, redefined.',
  location: 'Chicago, IL',
  registration: '26-437',

  // TODO: swap to the Royal T handles once they are set up.
  social: {
    instagram: 'https://www.instagram.com/plan_testosterone',
    facebook: 'https://www.facebook.com/share/1JBJ8HHSb4/?mibextid=wwXIfr',
    tiktok: 'https://www.tiktok.com/@plan.testosterone',
  },

  // Leave empty to hide the "Contact Us" link.
  contactEmail: '',
};

// Illinois Cottage Food Act wording. The website / online-sales notice uses
// "not subject to public health inspection"; the printed LABEL must use
// "not inspected by a health department".
export const cottageNotice =
  'This product was produced in a home kitchen not subject to public health inspection that may also process common food allergens. If you have safety concerns, contact your local health department.';
